/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { DataTypeCategory } from './DataTypeCategory';
import {
    DataTypeCategoryFromJSON,
    DataTypeCategoryFromJSONTyped,
    DataTypeCategoryToJSON,
} from './DataTypeCategory';

/**
 * 
 * @export
 * @interface DataTypeInfoDto
 */
export interface DataTypeInfoDto {
    /**
     * 
     * @type {string}
     * @memberof DataTypeInfoDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DataTypeInfoDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataTypeInfoDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DataTypeInfoDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {DataTypeCategory}
     * @memberof DataTypeInfoDto
     */
    dataTypeCategory?: DataTypeCategory;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof DataTypeInfoDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof DataTypeInfoDto
     */
    $type?: DataTypeInfoDtoTypeEnum;
}


/**
 * @export
 */
export const DataTypeInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoDataTypeInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.DataTypeInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataTypeInfoDtoTypeEnum = typeof DataTypeInfoDtoTypeEnum[keyof typeof DataTypeInfoDtoTypeEnum];



/**
 * Check if a given object implements the DataTypeInfoDto interface.
 */
export function instanceOfDataTypeInfoDto(value?: unknown): value is DataTypeInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataTypeInfoDtoTypeEnum)[0];
}

export function DataTypeInfoDtoFromJSON(json: any): DataTypeInfoDto {
    return DataTypeInfoDtoFromJSONTyped(json, false);
}

export function DataTypeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataTypeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'dataTypeCategory': json['dataTypeCategory'] == null ? undefined : DataTypeCategoryFromJSON(json['dataTypeCategory']),
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DataTypeInfoDtoToJSON(value?: DataTypeInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'dataTypeCategory': DataTypeCategoryToJSON(value['dataTypeCategory']),
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        '$type': value['$type'],
    });
}

